package utils

import js.intl.DateTimeFormat
import kotlin.js.Date

fun localDateFromString(string: String): String{
    return "${Date(string).toDateString()} ${Date(string).toTimeString()}"
}